import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    details: {
     '& > div > section:nth-of-type(2)': {
       marginTop: theme.spacing(3)
     }
    },
  })
);
